import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  makeStyles
} from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  field: {
    minWidth: 360,
    marginTop: theme.spacing(1)
  },
  chipsWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75)
  }
}));

const TicketTagsModal = ({ open, onClose, ticket, onSaved }) => {
  const classes = useStyles();
  const [tags, setTags] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) {
      return;
    }

    setSelectedValues(
      Array.isArray(ticket?.tags) ? ticket.tags.map(tag => String(tag.id)) : []
    );

    (async () => {
      try {
        const { data } = await api.get("/tickets/filter-options");
        setTags(Array.isArray(data?.tags) ? data.tags : []);
      } catch (error) {
        toastError(error);
      }
    })();
  }, [open, ticket]);

  const selectedTagIds = useMemo(
    () =>
      selectedValues
        .map(value => Number(value))
        .filter(value => !Number.isNaN(value)),
    [selectedValues]
  );

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put(`/tickets/${ticket.id}/tags`, {
        tagIds: selectedTagIds
      });
      toast.success("Tags atualizadas com sucesso");
      onClose();
      if (typeof onSaved === "function") {
        onSaved();
      }
    } catch (error) {
      toastError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Tags do ticket</DialogTitle>
      <DialogContent dividers>
        <FormControl variant="outlined" fullWidth className={classes.field}>
          <InputLabel id="ticket-tags-select-label">Selecione as tags</InputLabel>
          <Select
            labelId="ticket-tags-select-label"
            multiple
            value={selectedValues}
            onChange={(event) => setSelectedValues(event.target.value)}
            label="Selecione as tags"
            renderValue={(selected) => (
              <div className={classes.chipsWrap}>
                {tags
                  .filter(tag => selected.includes(String(tag.id)))
                  .map(tag => (
                    <Chip
                      key={tag.id}
                      size="small"
                      label={tag.name}
                      style={{
                        backgroundColor: `${tag.color}22`,
                        color: tag.color,
                        fontWeight: 700
                      }}
                    />
                  ))}
              </div>
            )}
          >
            {tags.map(tag => (
              <MenuItem key={tag.id} value={String(tag.id)}>
                <Chip
                  size="small"
                  label={tag.name}
                  style={{
                    backgroundColor: `${tag.color}22`,
                    color: tag.color,
                    fontWeight: 700
                  }}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined" disabled={saving}>
          Cancelar
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={saving}>
          Salvar tags
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketTagsModal;
